import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { pctChange } from './periods';

export const Delta = ({ cur, prev }) => {
  const p = pctChange(cur, prev);
  if (p === null) return <span className="text-xs font-semibold text-emerald-600">New</span>;
  const Icon = p > 0 ? TrendingUp : p < 0 ? TrendingDown : Minus;
  const color = p > 0 ? 'text-emerald-600 bg-emerald-50' : p < 0 ? 'text-red-600 bg-red-50' : 'text-gray-500 bg-gray-100';
  return (
    <span className={`inline-flex items-center gap-1 text-xs font-semibold px-1.5 py-0.5 rounded ${color}`}>
      <Icon className="w-3 h-3" />{p > 0 ? '+' : ''}{p}%
    </span>
  );
};

export const KpiCard = ({ label, cur, prev, big, testid }) => (
  <div className={`bg-white border rounded-xl p-4 ${big ? 'border-l-4 border-l-[#1a5c3b]' : ''}`} data-testid={testid}>
    <p className="text-gray-500 text-xs font-medium uppercase tracking-wide">{label}</p>
    <div className="flex items-end justify-between gap-2 mt-1">
      <p className={`${big ? 'text-3xl' : 'text-2xl'} font-bold text-gray-900 tabular-nums`} data-testid={`${testid}-value`}>{cur.toLocaleString('en-CA')}</p>
      <Delta cur={cur} prev={prev} />
    </div>
    <p className="text-[11px] text-gray-400 mt-1">vs {prev.toLocaleString('en-CA')} previous period</p>
  </div>
);
